(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InvoiceInfoBottomSheetController', InvoiceInfoBottomSheetController);

    InvoiceInfoBottomSheetController.$inject = ['$mdBottomSheet', 'entity'];

    function InvoiceInfoBottomSheetController($mdBottomSheet, entity) {
        var vm = this;

        vm.invoiceInfo = entity.invoiceInfo;
        vm.mode = entity.mode; // MAIN_ACTIONS , OTHER_ACTIONS ,
        vm.showUseCredit = entity.showUseCredit; // MAIN_ACTIONS , OTHER_ACTIONS ,

        vm.itemClick = itemClick;
        vm.close = close;
        vm.canEditInsertPaymentLog = canEditInsertPaymentLog;

        function itemClick(txt) {
            $mdBottomSheet.hide(txt);
        }

        function close() {
            $mdBottomSheet.hide();
        }


        function canEditInsertPaymentLog() {


            if (vm.invoiceInfo.status && (vm.invoiceInfo.status == 'SETTLEMENT' || vm.invoiceInfo.status == 'VOID'))
                return false;

            return true;
        }
    }
})();
